// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"OQ","mainContent":"PQ","activeSidebar":"QQ"};